<template>
    <div v-if="popupVisible"
        class="prizes-and-rules">
        <div :class="{content: true, 'closing-popup': closing}">
            <!-- 返回按钮 -->
            <div class="click-to-back"
                @click="clickToBack">
                回到拆盲盒页面
                <div class="triangle">&#9660;</div>
            </div>
            <!-- 奖品池 -->
            <div class="prize-pool-content">
                <span class="block-title">奖品池</span>
                <!-- 超过4个 -->
                <vue-seamless-scroll v-if="prizeList.length > 4"
                    :data="prizeList"
                    :class-option="classOption"
                    class="warp"
                    :style="{'width':100 * prizeList.length * 2 + 'px'}">
                    <ul class="ul-item"
                        :style="{'width':100 * prizeList.length + 'px'}">
                        <li v-for="(item, index) in prizeList"
                            :key="index"
                            class="li-item">
                            <img class="prize-img"
                                :src="item.imgUrl">
                            <div class="li-item-text">{{ item.goodsName }}</div>
                        </li>
                    </ul>
                </vue-seamless-scroll>
                <!-- 小于等于4个 -->
                <div v-else>
                    <ul class="ul-itm"
                        :style="{'justify-content': prizeList.length < 4 ? 'space-around' : 'space-between' }">
                        <li v-for="(item, index) in prizeList"
                            :key="index"
                            class="li-itm">
                            <img class="li-img"
                                :src="item.imgUrl">
                            <div class="li-item-text">{{ item.goodsName }}</div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- 我的中奖记录 -->
            <my-prizes :myPrizesList="myRecord"
                @viewPrizes="viewPrizes"></my-prizes>
            <!-- 活动规则 -->
            <div class="activity-rules-content">
                <span class="block-title">活动规则</span>
                <div class="activity-rules-content-bottom"
                    v-html="ruleDesc"></div>
            </div>
        </div>
    </div>
</template>
<script>
import vueSeamlessScroll from 'vue-seamless-scroll';
import myPrizes from './my-prizes.vue';

export default {
  name: 'PrizesAndRulesPopup',
  components: { vueSeamlessScroll, myPrizes },
  props: {
    // 是否显示弹窗
    popupVisible: {
      type: Boolean,
      default: false,
    },
    // 奖品池列表
    prizeList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 规则描述
    ruleDesc: {
      type: String,
      default: '',
    },
    // 我的中奖记录
    myRecord: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      classOption: {
        limitMoveNum: 5,
        direction: 2,
        step: 0.5,
      },
      closing: false,
    };
  },
  computed: {},
  created() {},
  methods: {
    clickToBack() {
      this.closing = true;
      setTimeout(() => {
        this.$emit('closePopup');
        this.closing = false;
      }, 300);
    },
    viewPrizes(item) {
      this.$emit('viewPrizes', item);
    },
  },
};
</script>

<style lang="scss" scoped>
.prizes-and-rules {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.65);
  height: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  overflow: hidden;
  .content {
    background-color: #f9f9f9;
    border-radius: 20px 20px 0 0;
    margin-top: 26vh;
    height: 74vh;
    // 添加打开上滑效果
    animation: slideUp 0.6s;
    width: 100vw;
    text-align: center;
    padding: 15px;
    flex-direction: column;
    overflow-y: scroll;
    .click-to-back {
      font-size: 14px;
      font-family: HONORSansBrand-Regular;
      color: #181818;
      font-weight: 400;
    }
    .prize-pool-content {
      margin: 10px 0;
      background-color: #fff;
      border-radius: 7px;
      padding: 15px 0;
      overflow: hidden;

      .warp {
        margin: 0 auto;
        overflow: hidden;
      }
      .ul-item {
        display: flex;
        align-items: flex-start;
        justify-content: center;
        text-align: center;
        .prize-img {
          height: 70px;
          width: 70px;
          margin: 15px;
        }
      }
      .li-item-text {
        font-size: 12px;
        color: #333333;
        font-weight: 400;
        text-align: center;

        overflow: hidden;
        -webkit-line-clamp: 2;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
      }
      .ul-itm {
        display: flex;
        margin: 15px;
        .li-itm {
          width: 23%;
          .li-img {
            width: 15.733vw;
            height: 15.733vw;
          }
        }
      }
    }

    .activity-rules-content {
      margin-top: 10px;
      background-color: #fff;
      border-radius: 7px;
      padding: 15px;
      overflow: hidden;

      .activity-rules-content-bottom {
        margin-top: 14px;
        font-size: 12px;
        color: #333333;
        line-height: 20px;
        font-weight: 400;
        overflow: hidden;
        overflow-y: scroll;
        text-align: left;
        word-break: break-all;
      }
      .activity-rules-content-bottom /deep/ a {
        color: #2d8cf0 !important;
      }
      .activity-rules-content-bottom /deep/ img {
        width: 100%;
        margin-right: 5px;
      }
      .activity-rules-content-bottom /deep/ pre {
        white-space:pre-wrap;
      }
    }
  }
  .block-title {
    font-size: 16px;
    color: #256fff;
    text-align: center;
    font-weight: 600;
  }
  .closing-popup {
    animation: slideDown 0.4s;
  }
}

// 上滑
@keyframes slideUp {
  0% {
    margin-top: 100vh;
  }
  100% {
    margin-top: 26vh;
  }
}
// 下滑
@keyframes slideDown {
  0% {
    margin-top: 26vh;
  }
  100% {
    margin-top: 100vh;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/components/prizes-and-rules-popup.vue